import * as React from "react";
const SvgRootType = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 13 13", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 11.8, height: 11.8, x: 0.6, y: 0.6, stroke: "currentColor", strokeWidth: 1.2, rx: 5.9 }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "M4.25 7.5c0-1.5 1.5-2.5 2.25-1s2.25.5 2.25-1" }));
export {
  SvgRootType as default
};
//# sourceMappingURL=root-type.js.map
